import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import { Accordion } from '@wellbeingxltd/fe-lib/components'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import AnimatedLogo from '@wellbeingxltd/fe-lib/images/dist/logo/AnimatedLogo.gif'
import { AnalyticsActions } from 'store/models/analytics'
import FinanceActions from 'store/models/finance'
import SupplierActions from 'store/models/supplier'
import { Table } from 'components'
import { invoicesColumns, licenseColumns, summariesColumns } from './config'
import { invoicesTableTitle } from './constants'

const Invoices = () => {
    const dispatch = useDispatch()
    const { invoicesByDates, invoicesWithMonthHeadings, licenseFeesInvoices, loadingFinance, summaries } = useSelector(GET_STORE.FINANCE)
    const { supplier } = useSelector(GET_STORE.SUPPLIER)
    const [downloading, setDownloading] = useState(false)

    useEffect(() => {
        document.title = 'Invoices | Betterspace Supplier'
        if (_.isEmpty(licenseFeesInvoices) || _.isEmpty(licenseFeesInvoices) || _.isEmpty(summaries)) dispatch(FinanceActions.getFinance())
        if (!supplier) {
            dispatch(SupplierActions.getSupplier())
        }
        dispatch(AnalyticsActions.postAnalytics('[Invoices] componentDidMount', null))
    }, [])

    const downloadMonthInvoices = (date = 'Month') => {
        setDownloading(date)
        const zip = new JSZip()
        const zipName = `${date} Invoices.zip` // e.g. '2021-05 Invoices.zip'
        const monthInvoices = invoicesByDates[date]
        const files = monthInvoices.map(invoice => invoice.pdf)

        files.forEach((url, count) => {
            const lastSlash = url.lastIndexOf('/')
            const fileName = url.substr(lastSlash + 1, url.lastIndexOf('.') - lastSlash - 1)

            fetch(url, {
                headers: {
                    Origin: 'http://localhost:3000',
                },
            })
                .then(response => {
                    const blob = response.blob()
                    zip.file(fileName + '.pdf', blob, {
                        binary: true,
                    })

                    if (count === files.length - 1) {
                        setTimeout(() => {
                            zip.generateAsync({
                                type: 'blob',
                            }).then(content => {
                                saveAs(content, zipName)
                                dispatch(AnalyticsActions.postAnalytics('[Invoices] Download ZIP', zipName))
                            })
                        }, 1000)
                    }
                })
                .catch(error => console.log(error))
                .finally(() => setDownloading(null))
        })
    }

    const sendAnalytics = ({ target }) => {
        const attr = target.dataset.analyticslink
        if (attr === 'true') {
            const to = target.href
            const arrFromString = to.split('/')
            const fileName = arrFromString[arrFromString.length - 1]
            const arrFileName = fileName.split('.')
            const extension = arrFileName[arrFileName.length - 1].toUpperCase()
            to && dispatch(AnalyticsActions.postAnalytics(`[Invoices] Download ${extension}`, to))
        }
    }

    if (loadingFinance) {
        return (
            <div className="centerLoader">
                <img src={AnimatedLogo} width="64px" alt="Loading, please wait" />
            </div>
        )
    }

    return (
        <>
            <div className="financials-head">
                <h1>Invoices</h1>
            </div>
            {invoicesWithMonthHeadings && (
                <Accordion title={invoicesTableTitle}>
                    <Table
                        tableClassName="invoicesTable"
                        stickyHeader={true}
                        loadingData={loadingFinance}
                        data={invoicesWithMonthHeadings}
                        columns={invoicesColumns}
                        emptyStateText="No invoices for clients found"
                        downloadMonthInvoices={downloadMonthInvoices}
                        downloading={downloading}
                        clickHandler={sendAnalytics}
                        showTitle={false}
                    />
                </Accordion>
            )}

            <Accordion title="License fees">
                <Table
                    tableClassName="licenseFeesTable"
                    stickyHeader={true}
                    loadingData={loadingFinance}
                    data={licenseFeesInvoices}
                    columns={licenseColumns}
                    emptyStateText="No License Fees invoices were found"
                    clickHandler={sendAnalytics}
                    showTitle={false}
                />
            </Accordion>

            <Accordion title="Summaries">
                <Table
                    tableClassName="summariesTable"
                    stickyHeader={true}
                    loadingData={loadingFinance}
                    data={summaries}
                    columns={summariesColumns}
                    emptyStateText="No invoices were found"
                    clickHandler={sendAnalytics}
                    showTitle={false}
                />
            </Accordion>
        </>
    )
}

export default Invoices
